import React from 'react';
import { Button, ButtonPriority } from 'wix-ui-tpa/cssVars';
import { st, classes } from './LoadMoreButton.st.css';
import { useDailyAgendaActions } from '../../../components/DailyAgenda/hooks/useDailyAgendaActions';
import { useWidgetViewModel } from '../../../components/DailyAgenda/hooks/useWidgetViewModel';
import { Spinner } from '../Spinner/Spinner';
import { BodyDataHooks } from '../../../components/DailyAgenda/Widget/Body/const';

export type LoadMoreButtonProps = {
  className?: string;
};

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  className,
}) => {
  const { loadMoreViewModel } = useWidgetViewModel();
  const { onLoadMore } = useDailyAgendaActions();
  const { isLoading, buttonText, hasMore } = loadMoreViewModel || {};

  if (!hasMore && !isLoading) {
    return null;
  }

  return (
    <div className={st(classes.root, className)} data-hook={BodyDataHooks.Main}>
      {isLoading ? (
        <div
          className={classes.spinner}
          data-hook={BodyDataHooks.LoadMoreSpinner}
        >
          <Spinner show={true} />
        </div>
      ) : (
        <Button
          className={classes.loadMoreButton}
          priority={ButtonPriority.secondary}
          onClick={() => onLoadMore()}
          data-hook={BodyDataHooks.LoadMoreButton}
          disabled={isLoading}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};
